import styled from 'styled-components';

export const TitleTooltip = styled.div`
  position: fixed;
  background: ${({ theme }) => theme.landing.cardBg};
  color: ${({ theme }) => theme.landing.text};
  border: 1px solid ${({ theme }) => theme.landing.cardBorder};
  padding: 8px 12px;
  border-radius: 6px;
  font-size: 12px;
  line-height: 1.4;
  max-width: 420px;
  width: max-content;
  white-space: normal;
  word-break: break-word;
  pointer-events: none;
  z-index: 9999;
`;

export const TitleCellHoverGroup = styled.div`
  position: relative;
  display: block;
  max-width: 100%;
  cursor: default;

  &:hover ${TitleTooltip} {
    opacity: 1;
    visibility: visible;
  }
`;

export const CellPrimaryText = styled.div`
  color: ${({ theme }) => theme.landing.text};
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 300px;
  @media (max-width: ${({ theme }) => theme.landingBreakpoints.md}) {
    max-width: 250px;
  }
`;
